import { get } from './apiUtils';

const defaultUrl = '/RawMatSuppliers/';

export default {
  getRawMatSupplierList: () => get(defaultUrl),
};
